import { FaTimes } from "react-icons/fa";

export const Modal = ({ isOpen, onClose, title, icon, children }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
            <div className="glass-card rounded-xl p-6 max-w-md w-full mx-auto animate-fadeIn">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold flex items-center text-white">
                        {icon}
                        {title}
                    </h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
                        <FaTimes className="w-6 h-6" />
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
};